import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import JobCardsList from './JobCardsList';
import JobCardForm from './JobCardForm';
import JobCardDetails from './JobCardDetails';
const { rootUrl } = require('../../../config/config');

const JobCardsManagement = () => {
    const { token } = useAuth();
    const navigate = useNavigate();
    const authToken = token || localStorage.getItem('authToken') || 'default-token';

    const [cars, setCars] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [selectedJobCard, setSelectedJobCard] = useState(null);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        fetchCars();
    }, []);

    const fetchCars = async () => {
        try {
            const response = await axios.get(
                `${rootUrl}/cars`,
                { headers: { 'Authorization': `Bearer ${authToken}` } }
            );
            setCars(response.data || []);
        } catch (error) {
            console.error('Error fetching cars:', error);
        }
    };

    const handleCreate = () => {
        setSelectedJobCard(null);
        setShowForm(true);
    };

    const handleEdit = (jobCard) => {
        setSelectedJobCard(jobCard);
        setShowForm(true);
    };

    const handleViewDetails = (jobCard) => {
        navigate(`/job-cards/${jobCard.id}`, { state: { jobCard } });
    };

    const handleFormSuccess = () => {
        setShowForm(false);
        setSelectedJobCard(null);
        // Refresh list will be handled by JobCardsList component
    };

    const handleStatusUpdate = (updatedJobCard) => {
        setSelectedJobCard(updatedJobCard);
        // Refresh list will be handled by JobCardsList component
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
            <JobCardsList
                onView={handleViewDetails}
                onEdit={handleEdit}
                onCreate={handleCreate}
            />

            {/* Job Card Form Dialog */}
            <JobCardForm
                open={showForm}
                onClose={() => {
                    setShowForm(false);
                    setSelectedJobCard(null);
                }}
                onSuccess={handleFormSuccess}
                jobCard={selectedJobCard}
                cars={cars}
            />

            {/* Job Card Details Dialog */}
            {selectedJobCard && (
                <JobCardDetails
                    open={showDetails}
                    onClose={() => {
                        setShowDetails(false);
                        setSelectedJobCard(null);
                    }}
                    jobCardId={selectedJobCard.id}
                    onEdit={handleEdit}
                    onStatusUpdate={handleStatusUpdate}
                />
            )}
        </div>
    );
};

export default JobCardsManagement;

